"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgNoLuggage = function SvgNoLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.203 12.575v-4.6c0-1.619 0-2.48-4.087-2.763-.155-.011-.524-.14-.524-.295V2.848c0-.375 0-1.147-.832-1.533C14.278 1.092 13.526 1 12.01 1s-2.269.081-2.75.315c-.832.386-.832 1.167-.832 1.533v2.068a.298.298 0 0 1-.28.295c-.42.028-.798.062-1.14.102L3.19 1.496a1.375 1.375 0 1 0-1.945 1.945l18.782 18.781a1.375 1.375 0 0 0 1.944-1.944l-1.789-1.79v-5.913h.02Zm-1.62 10.233L3.826 7.974v11.058c0 .913.101 1.84 1.01 2.207.122.05.212.163.212.296v.485c0 .54.44.98.98.98H6.5c.602 0 .879-.432.957-.927.027-.17.17-.306.342-.294 1.034.073 2.551.116 4.191.116 1.64 0 3.2-.035 4.238-.114.172-.013.318.123.345.294.077.494.354.925.955.925H18c.218 0 .42-.072.583-.192ZM13.886 4.823a.295.295 0 0 1-.299.295 100.24 100.24 0 0 0-3.169-.003.297.297 0 0 1-.304-.296V3.065a.27.27 0 0 1 .233-.274c.296-.035.798-.064 1.653-.064s1.346.034 1.642.067a.279.279 0 0 1 .244.282v1.747Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgNoLuggage);
var _default = exports["default"] = Memo;